import axios from 'axios';
import {
    treatmentRequest,
    treatmentsSuccess,
    treatmentCreateSuccess,
    treatmentUpdateSuccess,
    treatmentDeleteSuccess,
    treatmentFail,
} from '../slices/treatmentSlice';

// GET active treatments — for billing forms (all logged-in users)
export const getTreatments = () => async (dispatch) => {
    try {
        dispatch(treatmentRequest());
        const { data } = await axios.get('/api/v1/treatments');
        dispatch(treatmentsSuccess(data.treatments));
    } catch (err) {
        dispatch(treatmentFail(err.response?.data?.message || 'Failed to load treatments'));
    }
};

// GET all treatments including inactive — for admin manage page
export const getAdminTreatments = () => async (dispatch) => {
    try {
        dispatch(treatmentRequest());
        const { data } = await axios.get('/api/v1/admin/treatments');
        dispatch(treatmentsSuccess(data.treatments));
    } catch (err) {
        dispatch(treatmentFail(err.response?.data?.message || 'Failed to load treatments'));
    }
};

// POST — create new treatment
export const createTreatment = (treatmentData) => async (dispatch) => {
    try {
        dispatch(treatmentRequest());
        const { data } = await axios.post('/api/v1/admin/treatments', treatmentData);
        dispatch(treatmentCreateSuccess(data.treatment));
    } catch (err) {
        dispatch(treatmentFail(err.response?.data?.message || 'Failed to create treatment'));
    }
};

// PUT — update treatment
export const updateTreatment = (id, treatmentData) => async (dispatch) => {
    try {
        dispatch(treatmentRequest());
        const { data } = await axios.put(`/api/v1/admin/treatments/${id}`, treatmentData);
        dispatch(treatmentUpdateSuccess(data.treatment));
    } catch (err) {
        dispatch(treatmentFail(err.response?.data?.message || 'Failed to update treatment'));
    }
};

// DELETE — delete treatment
export const deleteTreatment = (id) => async (dispatch) => {
    try {
        dispatch(treatmentRequest());
        await axios.delete(`/api/v1/admin/treatments/${id}`);
        dispatch(treatmentDeleteSuccess(id));
    } catch (err) {
        dispatch(treatmentFail(err.response?.data?.message || 'Failed to delete treatment'));
    }
};

